import { render } from "./GerenciarPartidaView.vue?vue&type=template&id=3b100eae&scoped=true"
import script from "./GerenciarPartidaView.vue?vue&type=script&lang=js"
export * from "./GerenciarPartidaView.vue?vue&type=script&lang=js"

import "./GerenciarPartidaView.vue?vue&type=style&index=0&id=3b100eae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b100eae"]])

export default __exports__